import maintainRequest from "@/maintain/utils/maintainRequest";

export default function getOwnDetails() {
  return maintainRequest({
    url: `/user/maintenanceMan/maintenanceMan/getOwnDetails`,
  });
}
